export default class GTagHelper {
    public static setConfig(targetId: string, configInfo: any = null) {
        // ConfigInfo: { parameterName: parameterValue }
        if ((<any>window).gtag) {
            (<any>window).gtag("config", targetId, configInfo);
        }
    }

    public static getValue(target: string, fieldName: string) {
        // Get values from gtag (including values set with the set command)
        // Target: UA-XXXXXXXX-Y
        if ((<any>window).gtag) {
            (<any>window).gtag("get", target, fieldName, (field: any) => { return field });
        }
    }

    public static setValue(valuePair: any) {
        // Set values that persist across all the subsequent gtag() calls on the page
        // ValuePair: { parameterName: parameterValue }
        if ((<any>window).gtag) {
            (<any>window).gtag("set", valuePair);
        }
    }

    public static sendEvent(eventName: string, eventParams: any = null) {
        // EventParams: { parameterName: parameterValue }
        if ((<any>window).gtag) {
            (<any>window).gtag("event", eventName, eventParams);
        }
    }
}